// extracted by mini-css-extract-plugin
export default {"input":"InputStyles_input__WlVdt","label":"InputStyles_label__vknvO"};